import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const NothingFoundWrapper = styled.div`
  margin: 184px auto;
  text-align: center;

  img {
    @media ${breakpoints.md} {
      width: 380px;
    }

    @media ${breakpoints.xs} {
      width: 220px;
    }
  }

  > p:first-of-type {
    margin: 28px 0 16px;

    @media ${breakpoints.xs} {
      margin: 16px 0 8px;
    }
  }

  a {
    margin: 24px auto;
    padding: 12px 24px;
    border-radius: 8px;
    display: block;
    width: fit-content;
    background-color: var(--orange-primary);
  }
`;
